<script setup>
import CounterNumberValue from "@shared/components/atoms/CounterNumberValue.vue"
import {useAccountStore} from "@shared/stores/AccountStore"
import {useAuthStore} from "@shared/stores/AuthStore"
import {useWalletStore} from "@shared/stores/WalletStore"

const accountStore = useAccountStore()
const authStore = useAuthStore()
const walletStore = useWalletStore()
</script>

<template>

    <div id="divHeaderWallet">
        <template v-if="!accountStore.isAuthenticated">
            <button class="registerlink" @click="authStore.setAuthModalVisibility(true, 'registration')">Register</button>
            <button class="loginbutton" @click="authStore.setAuthModalVisibility(true, 'login')">Login</button>
        </template>

        <template v-else>

            <template v-if="walletStore.isWalletFetched">
                <div id="btnOpenWallet" @click="() => walletStore.setWalletModalVisibility(true)">CASHIER</div>
                <div id="divWalletAmount" @click="() => walletStore.setWalletModalVisibility(true)">
                    <CounterNumberValue
                        :count="walletStore.getCombinedBalance"
                        :decimal-places="2"
                        prefix="R"
                    />
                </div>
            </template>

        </template>
    </div>

</template>

<style>
#divHeaderWallet {
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 10px;
    margin-right: 5px;

    #btnOpenWallet {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80px;
        border-radius: 5px;
        border: 2px solid #9c13b0;
        background-color: #9c13b0;
        line-height: 34px;
        font-size: 14px;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
        transition: color 0.25s;

        &:hover {
            background-color: transparent;
            color: #9c13b0;
        }

        @media (max-width: 400px) {
            width: 70px;
        }
    }

    @media (max-width: 800px) {
        /* font-size: 12px; */

        #divWalletAmount {
            
        }
    }

    @media (max-width: 400px) {
        column-gap: 5px;
    }
}
</style>
